<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <span style="font-size: 9pt;"><b>*</b> Campos obrigatórios</span>
                </div>
                <div class="col-md-9">
                  <label>Nome <b>*</b></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pessoa.nome"
                    id="nome"
                  />
                </div>
                <div class="col-md-3">
                  <label>Gênero <b>*</b></label>
                  <select v-model="pessoa.sexo" class="form-control">
                    <option :value="'0'">Feminino</option>
                    <option :value="'1'">Masculino</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label>Nome da mãe</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pessoa.nome_mae"
                  />
                </div>
                <div class="col-md-6">
                  <label>E-mail</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pessoa.email"
                  />
                </div>
                <div class="col-md-3">
                  <label>CNS</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pessoa.cns"
                  />
                </div>
                <div class="col-md-3">
                  <label>Telefone <b>*</b></label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'(99) 99999-9999'"
                    v-model="pessoa.telefone"
                  />
                </div>
                <div class="col-md-3">
                  <label>RG</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pessoa.rg"
                    v-mask="'99.999.999-9'"
                  />
                </div>
                <div class="col-md-3">
                  <label>CPF <b>*</b></label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'999.999.999-99'"
                    v-model="pessoa.cpf"
                  />
                </div>
                <div class="col-md-12">
                  <label>Alergias</label>
                  <input
                    type="text"
                    v-model="pessoa.alergias"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-2">
                  <label>CEP</label>
                  <input
                    type="text"
                    v-model="pessoa.cep"
                    class="form-control"
                    v-on:keyup="buscar"
                    v-mask="'99999-999'"
                  />
                </div>
                <div class="col-md-5">
                  <label> Logradouro</label>
                  <input
                    type="text"
                    v-model="pessoa.logradouro"
                    class="form-control"
                  />
                </div>
                <div class="col-md-2">
                  <label>Nº</label>
                  <input
                    type="text"
                    id="inputNumero"
                    v-model="pessoa.numero"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label>Complemento</label>
                  <input
                    type="text"
                    v-model="pessoa.complemento"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label>Bairro</label>
                  <input
                    type="text"
                    v-model="pessoa.bairro"
                    class="form-control"
                  />
                </div>
                <div class="col-md-5">
                  <label>Cidade</label>
                  <input
                    type="text"
                    v-model="pessoa.cidade"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label>Estado</label>
                  <input
                    type="text"
                    v-model="pessoa.estado"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12 text-center my-2" v-if="$route.params.id">
                  <img :src="pessoa.foto" style="border: 1px solid black; border-radius: 8px;">
                </div>
                <div class="col-md-12 mt-1" v-else>
                  <div class="col-12 d-flex justify-content-center">
                    <video ref="video" autoplay width="640" height="480" style="border: 1px solid black; border-radius: 8px;"></video>
                  </div>
                  <div class="col-12 text-center my-1">
                    <button class="btn btn-sm btn-outline-primary" @click="tirarFoto">Tirar foto</button>
                  </div>
                  <div class="col-12 d-flex justify-content-center">
                    <canvas ref="canvas" width="640" height="480" style="border: 1px solid black; border-radius: 8px;"></canvas>
                  </div>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar <i class="fa fa-save"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      pessoa: {
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
      },
      empresas: [],
      atencao_continuadas: [],
    };
  },
  computed: {},
  methods: {
    async iniciarCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.video.srcObject = stream;
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
      }
    },
    tirarFoto() {
      const self = this;
      const video = self.$refs.video;
      const canvas = self.$refs.canvas;
      const context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      self.pessoa.foto = canvas.toDataURL("image/png");
      self.fecharCamera();
    },
    fecharCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop()); 
        this.stream = null;
        this.$refs.video.srcObject = null;
      }
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "cadastramento-facial";

      self.$loading(true);

      if (self.pessoa.id) {
        api += "/" + self.pessoa.id;
        self.pessoa._method = "PUT";
      }

      axios
        .post(api, self.pessoa)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          // this.$router.push("/");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.pessoa.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.pessoa.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }

            self.endereco = endereco;
            self.pessoa.logradouro = self.endereco.logradouro;
            self.pessoa.bairro = self.endereco.bairro;
            self.pessoa.estado = self.endereco.uf;
            self.pessoa.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    // getPessoas: function (id) {
    //   const self = this;
    //   const api = self.$store.state.api + "pessoas/" + id;

    //   self.$loading(true);

    //   axios
    //     .get(api)
    //     .then((response) => {
    //       self.$loading(false);
    //       self.pessoa = response.data.data[0];
    //     })
    //     .catch((error) => {
    //       self.$loading(false);
    //       self.$message(null, error.response.data, "error");
    //     });
    // },
  },
  mounted: function () {
    const self = this;
    $("#nome").focus();
    // let id = self.$route.params.id;

    // if (id) {
    //   self.getPessoas(id);
    // }else{
      setTimeout(() => {
        self.iniciarCamera();
      }, 1000);
    // }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>